// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__IdYqY","header":"PatientQuestionnaire_header__2kHkC","info":"PatientQuestionnaire_info__3o_go"};